import { AichaAPI } from "@radarly/api/aicha";
import { FocusMetrics } from "@radarly/models/aicha";
import { BaseSearchParams } from "@radarly/models/search";
import { AichaRepo } from "./AichaRepo";

interface Dependencies {
  aichaAPI: AichaAPI;
}

export class ConnectedAichaRepo implements AichaRepo {
  api: AichaAPI;
  public constructor(dependencies: Dependencies) {
    this.api = dependencies.aichaAPI;
  }
  public getDiscoveryPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ) {
    return this.api.getDiscoveryPostlistSummary(pid, request, focusMetrics);
  }
  public getPostlistSummary(
    pid: number,
    request: BaseSearchParams,
    focusMetrics: FocusMetrics[]
  ) {
    return this.api.getPostlistSummary(pid, request, focusMetrics);
  }
}
